import { api } from "lib";

export const getStpPerformGradeConfig = async (params = {}) => {
    return await api.post("/v1/stpPerform/getStpPerformGradeConfig", params);
};

export const getStpPerformList = async (params = {}) => {
    return await api.post("/v1/stpPerform/getStpPerformList", params);
};

export const editStpPerformGradeConfig = async (params = {}) => {
    return await api.post("/v1/stpPerform/editStpPerformGradeConfig", params);
};

export const editStpPerformList = async (params = {}) => {
    return await api.post("/v1/stpPerform/editStpPerform", params);
};